import { render, staticRenderFns } from "./SysClientAccessLogForm.vue?vue&type=template&id=64c8a398&"
import script from "./SysClientAccessLogForm.vue?vue&type=script&lang=js&"
export * from "./SysClientAccessLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports